/**
 * Container for SelectPunch
 * Approve CTA
 */
import React, { useState, useEffect, useMemo } from "react";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import moment from "moment";
import {
  makeStyles,
  Grid,
  Typography,
  CircularProgress,
  Button,
  Box,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import SelectPunch from "./SelectPunch";
// import workerData from "DATA/worker";
// import empPunches from "DATA/punches";
import {
  getWorkerPunchRecords,
  approvePunch,
  deleteIndividualPunch,
} from "services";
import LoadingButton from "components/LoadingButton";
import Confirmation from "components/Confirmation";
import { SUCCESS_COLOR } from "config/CONSTANTS";
// import { sharedContext } from "pages/Review/ReviewView";
import TotalHours from "./TotalHours";
import { useSelector } from "react-redux";
import { dateConfig } from "config";

const useStyles = makeStyles((theme) => ({
  root: {},
  ...theme.global,
  successText: {
    color: theme.success,
  },
  paddingBottom: {
    paddingBottom: 10,
  },
}));

const PunchList = (props) => {
  const SUCCESS_MSG_SHOWTIME = 5000;
  const classes = useStyles();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState("");
  // Approve button states
  const [isApproveLoading, setIsApproveLoading] = useState(false);
  const [approveError, setapproveError] = useState("");
  const [approveSuccess, setApproveSuccess] = useState("");

  const [totolHours, setTotalHours] = useState("");

  //meal and activity hours in footer
  const [mealHours, setMealHours] = useState("");
  const [activityHours, setActivityHours] = useState("");

  const [disableApprove, setdisableApprove] = useState(true);

  // const punches = empPunches;
  // const startDate = "01 jun 2020";

  /**
   * sharedContext for "selectedWorker" and "allWorkers"
   * 1. get all the workers reporting to the signed in supervisor.
   * 2. set the list of workers and selected worker in context for further use.
   */
  const [allPunches, setAllPunches] = useState({});
  const [selected, setSelected] = React.useState([]); // Date collection
  const [selectedPunches, setSelectedPunches] = React.useState([]); // punch record collection
  // const [approvedFlag, setApprovedFlag] = useState(false); // use flag to re-render list.
  const [confirmationBox, setConfirmationBox] = useState({
    isOpen: false,
    title: t("pgPunch.tlConfirmation"),
    subTitle: t("pgReview.msgDeleteSuccess"),
  });
  const { user } = useSelector((state) => state.user.auth);
  const deleteHandler = (punchRow) => {
    deleteIndividualPunch(punchRow.id, user.workerId,punchRow.inLocalTS,punchRow.outLocalTS)
      .then((result) => {
        console.log("result:", result);
        if (result) {
          setConfirmationBox({ ...confirmationBox, isOpen: true });
        }
      })
      .catch((error) => {
        console.log("Error while individual delete:", error);
      });
    let data = allPunches.data.filter((punch) => punch.id != punchRow.id);
    setAllPunches({ data: data });
  };

  const deleteDone = () => {
    setConfirmationBox({ ...confirmationBox, isOpen: false });
  };

  useMemo(() => {
    setIsLoading(true);
    setLoadingError("");
    setSelected([]);
    setSelectedPunches([]); // Reset selected Punches.

    if (props.worker && props.worker.workerId) {
      getWorkerPunchRecords(
        props.worker.workerId,
        moment(props.weekStartDate).format(dateConfig.format6),
        moment(new Date(props.weekStartDate)).add(7, "days").format(dateConfig.format6)
        // moment(startDate).toISOString(),
        // moment(new Date(startDate)).add(6, "days").toISOString()
      )
        .then((data) => {
          // setAllPunches(empPunches);
          if (data && data.length > 0) {
            setAllPunches({ data });
            setLoadingError("");
          } else {
            setAllPunches({});
            setLoadingError("pgReview.noPunchesForWorker");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.error("Err in getWorkerPunches Response: ", err);
          setIsLoading(false);
          setLoadingError("pgReview.errLoadingPunchRecords");
        });
    } else {
      if (
        props.allWorkers &&
        props.selectedTeam &&
        props.allWorkers[props.selectedTeam]
      ) {
        setIsLoading(false);
        setLoadingError("pgReview.errLoadingSelectedEmployeeId");
      } else {
        setIsLoading(false);
        setLoadingError("pgReview.noWorkerForManager");
      }
    }
  }, [props.worker, props.weekStartDate, props.selectedTeam]);
  // }, [props.worker, props.weekStartDate, approvedFlag]);

  /**
   * function to approve selected punch records.
   * @param: {array} - array of punch IDs to be approved.
   * @return: {void}
   */
  const approveHandler = () => {
    const punchIds = selectedPunches;
    console.log("PunchList: approveHandler: punchRecords=", punchIds);
    setIsApproveLoading(true);
    setapproveError("");
    // Check if any punch records are selected for approval.
    if (punchIds.length > 0) {
      approvePunch(punchIds,user.workerId)
        .then((data) => {
          // setApprovedFlag(!approvedFlag);
          allPunches.data.map((item) => {
            if (selectedPunches.indexOf(item.id) >= 0) {
              item.status = "approved";
            }
          });
          setIsApproveLoading(false);
          setapproveError("");
          setSelected([]);
          setSelectedPunches([]); // Reset selected Punches.
          setApproveSuccess("pgReview.msgApproveSuccess");
          setTimeout(() => setApproveSuccess(""), SUCCESS_MSG_SHOWTIME);
          console.log("PUNCHES APPROVED===", data);
        })
        .catch((err) => {
          console.error("Err in approval of punches: ", err);
          setIsApproveLoading(false);
          setapproveError("pgReview.errApprovingPunchRecords");
        });
    } else {
      setIsApproveLoading(false);
      setapproveError("pgReview.errNothingToApprove");
    }
  };

  const punchListMarkup = (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            color="primary"
            className={classes.paddingBottom}
          >
            {props.worker && props.worker.firstName && props.worker.lastName
              ? props.worker.firstName +
                " " +
                props.worker.lastName +
                " (" +
                props.worker.workerId +
                ")"
              : ""}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <SelectPunch
            worker={props.worker}
            punchesData={allPunches}
            startDate={props.weekStartDate}
            useSelectedPunchsState={[selectedPunches, setSelectedPunches]}
            useSelectedState={[selected, setSelected]}
            setTotalHours={setTotalHours}
            deleteHandler={deleteHandler}
            setMealHours={setMealHours}
          />

          <TotalHours
            hours={totolHours}
            mealHours={mealHours}
            activityHours={(totolHours - mealHours).toFixed(2)}
          ></TotalHours>
        </Grid>
      </Grid>
      <Grid container justify={"flex-end"}>
        <Grid item className={classes.textRight}>
          <Box my={8}>
            <LoadingButton
              onClick={approveHandler}
              isLoading={isApproveLoading}
              disabled={disableApprove}
            >
              {t("pgReview.btnApprove")}
            </LoadingButton>
            <Typography variant="body2" color="error">
              {t(approveError)}
            </Typography>
            <Typography variant="body2" className={classes.successText}>
              {t(approveSuccess)}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Confirmation
        confirmationMsg={confirmationBox.isOpen}
        closeModalConfirmationMsg={deleteDone}
        confirmationMsgText={confirmationBox.subTitle}
        confirmationTitleText={confirmationBox.title}
      />
    </>
  );

  useEffect(() => {
    if (selectedPunches.length > 0) {
      setdisableApprove(false);
    } else {
      setdisableApprove(true);
    }
  }, [selectedPunches]);

  // return <>{punchListMarkup}</>;
  return (
    <>
      {isLoading ? (
        <CircularProgress />
      ) : loadingError ? (
        <Typography variant="body2" color="error">
          {/* {t(loadingError)} */}
          <Alert severity="info">{t(loadingError)}</Alert>
        </Typography>
      ) : (
        punchListMarkup
      )}
    </>
  );
};

PunchList.propTypes = {
  worker: PropTypes.object.isRequired,
  weekStartDate: PropTypes.any.isRequired,
  allWorkers: PropTypes.object.isRequired,
  selectedTeam: PropTypes.string.isRequired,
};

export default PunchList;
